import { NavLink } from "react-router-dom";
import {
  Users,
  UsersRound,
  UserPlus,
  History,
  MailPlus,
  BookUser,
} from "lucide-react";
import { cn } from "../../../../utils/utils";

const MENU = [
  {
    to: "/contacts/friends",
    label: "Danh sách bạn bè",
    icon: Users,
    description: "Danh sách bạn bè Zalo",
  },
  {
    to: "/contacts/groups",
    label: "Danh sách nhóm và cộng đồng",
    icon: UsersRound,
    description: "Nhóm Zalo đang tham gia",
  },
  {
    to: "/contacts/friend-requests",
    label: "Lời mời kết bạn",
    icon: UserPlus,
    description: "Lời mời đã nhận và đã gửi",
  },
  {
    to: "/contacts/group-invitations",
    label: "Lời mời vào nhóm và cộng đồng",
    icon: MailPlus,
    description: "Nhóm được mời tham gia",
  },
  {
    to: "/contacts/friend-history",
    label: "Lịch sử kết bạn",
    icon: History,
    description: "Toàn bộ log kết bạn",
  },
];

const ContactsSidebar = ({ className }) => {
  return (
    <aside
      className={cn(
        "w-64 shrink-0 bg-white border-r border-gray-100 flex flex-col",
        className,
      )}
    >
      <div className="px-4 py-3 border-b border-gray-100 flex items-center gap-2">
        <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
          <BookUser size={16} className="text-white" />
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold text-gray-900 truncate">
            Danh bạ
          </div>
          <div className="text-[11px] text-gray-500 truncate">
            Quản lý liên hệ Zalo
          </div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto p-2 space-y-0.5">
        {MENU.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors",
                  isActive
                    ? "bg-indigo-50 text-indigo-700 font-medium"
                    : "text-gray-700 hover:bg-gray-50",
                )
              }
              title={item.description}
            >
              {({ isActive }) => (
                <>
                  <Icon
                    size={16}
                    className={cn(
                      "shrink-0",
                      isActive ? "text-indigo-600" : "text-gray-400",
                    )}
                  />
                  <span className="truncate">{item.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="px-4 py-2.5 border-t border-gray-100 text-[11px] text-gray-400">
        akaBizChat · Danh bạ
      </div>
    </aside>
  );
};

export default ContactsSidebar;
